import { INSERT_ORDERED_LIST_COMMAND, REMOVE_LIST_COMMAND } from "@lexical/list";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import FormatListNumbered from "@mui/icons-material/FormatListNumbered";
import { IconButton, Tooltip } from "@mui/material";
import { useCallback } from "react";
import { ToolbarIconButton } from "./toolbar-icon-button";

import type { FC, MouseEventHandler } from "react";

interface OrderedListButtonProps {
  disabled?: boolean;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  label?: string;
  activeBlockType: boolean;
}

export const OrderedListButton: FC<OrderedListButtonProps> = ({
  disabled,
  label,
  onClick,
  activeBlockType,
  ...props
}) => {
  const [editor] = useLexicalComposerContext();

  const handleClick: MouseEventHandler<HTMLButtonElement> = useCallback(
    (e) => {
      editor.dispatchCommand(
        activeBlockType ? REMOVE_LIST_COMMAND : INSERT_ORDERED_LIST_COMMAND,
        undefined,
      );
      onClick?.(e);
    },
    [editor, onClick, activeBlockType],
  );

  return (
    <>
      {label ? (
        <ToolbarIconButton
          data-analytics-id="lexical-toolbar-numbered-list"
          disabled={disabled}
          data-testid="toolbar-button-numbered-list"
          aria-label="Numbered list"
          onClick={handleClick}
          label={label}
          icon={<FormatListNumbered />}
        />
      ) : (
        <Tooltip title="Numbered list">
          <span>
            <IconButton
              data-analytics-id="lexical-toolbar-numbered-list-2"
              disabled={disabled}
              data-testid="toolbar-button-numbered-list"
              aria-label="Numbered list"
              tabIndex={-1}
              onClick={handleClick}
              {...props}
            >
              <FormatListNumbered />
            </IconButton>
          </span>
        </Tooltip>
      )}
    </>
  );
};
